import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Import as ImportType, ImportListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const IMPORT_FIELDS = `activityDate archived channel createdDate email fileImportId id isScheduled locationId name orgId phone requestedAppointmentTime staff treatment type updatedDate utmCampaign utmMedium utmSource vendor version workspaceId`

const LIST_QUERY = graphql(`
  query ImportsStore($search: String, $pagination: PaginationInput, $sort: SortInput) {
    imports(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        activityDate
        archived
        channel
        createdDate
        email
        fileImportId
        id
        isScheduled
        locationId
        name
        orgId
        phone
        requestedAppointmentTime
        staff
        treatment
        type
        updatedDate
        utmCampaign
        utmMedium
        utmSource
        vendor
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query ImportDetailStore($id: ID!) {
    importDetail(id: $id) {
      activityDate
      archived
      channel
      createdDate
      email
      fileImportId
      id
      isScheduled
      locationId
      name
      orgId
      phone
      requestedAppointmentTime
      staff
      treatment
      type
      updatedDate
      utmCampaign
      utmMedium
      utmSource
      vendor
      version
      workspaceId
    }
  }
`)

export class ImportStore extends EntityStore<ImportType, ImportListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.imports,
      extractOne: (data: any) => data.importDetail,
    })
  }
}
